import { useEffect } from "react";

import { useStores } from "../../../context/StoreContext";
import { IHotkey } from "./IHotkey";

// Adds a IHotkey to AppStore to be read by HotkeysBinding.
export function Hotkey(props: IHotkey) {
    const { code, label, context, onHotkey } = props;
    const { appStore } = useStores();
    useEffect(() => {
        appStore.bindHotkey({ code, label, context, onHotkey });
        return () => {
            appStore.unbindHotkey(code);
        };
    }, [appStore, code, label, context, onHotkey]);

    return null;
}
